import gql from 'graphql-tag'

export const serverTaskFields = gql`
fragment autoTasksServerFields on AutomationTask {
	id
	name
	isActive
	typeId
	isWindows
	params {
		email
		daysBack
		daysDuration
		schedule {
			time
			weekDay
			date
			month
			year
		}
	}
}
`
